var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-md-4 p-3"},[_vm._m(0),_c('TransactionsTable',{attrs:{"source":'blusalt-core',"isFundTransfer":""}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SectionItem no-b-b mb-3"},[_c('p',{staticClass:"title"},[_vm._v("Transactions")])])
}]

export { render, staticRenderFns }